var _g, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitalsigns2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9777a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.306 33.28l-5.013 5.013a.999.999 0 101.414 1.414l5.013-5.013a.999.999 0 10-1.414-1.414zM27.694 33.28a.999.999 0 10-1.414 1.414l6.025 6.025a.997.997 0 001.414 0 .999.999 0 000-1.414l-6.025-6.025zM50.707 30.293a.999.999 0 00-1.414 0l-10 10a.999.999 0 101.414 1.414l10-10a.999.999 0 000-1.414z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 60a1 1 0 01-1-1V1a1 1 0 112 0v58a1 1 0 01-1 1z",
    fill: "#a0a4b1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58H1a1 1 0 110-2h58a1 1 0 110 2z",
    fill: "#a0a4b1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29H7a1 1 0 110-2h2a1 1 0 110 2zM9 25H7a1 1 0 110-2h2a1 1 0 110 2zM9 21H7a1 1 0 110-2h2a1 1 0 110 2zM9 17H7a1 1 0 110-2h2a1 1 0 110 2zM9 13H7a1 1 0 110-2h2a1 1 0 110 2zM9 9H7a1 1 0 110-2h2a1 1 0 110 2zM9 5H7a1 1 0 110-2h2a1 1 0 110 2z",
    fill: "#bdc3c7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.012,
    cy: 42.988,
    r: 5,
    fill: "#5789b7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 31,
    r: 5,
    fill: "#afdfbc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 28,
    r: 5,
    fill: "#afdfbc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 5,
    fill: "#5789b7"
  })));
}
export default SvgVitalsigns2;